import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BookingCalendar } from "../../../room-booking-management/calendar";
import BookingActionsProvider from "../../../room-booking-management/providers/BookingActionsProvider.vue";


export default {
  __name: 'ConcertRequestCalendarPage',
  props: {
  roomId: { type: Number, required: true },
  roomBookingApiUrl: { type: String, required: true },
  userApiUrl: { type: String, required: true },
  concertRequestCalendarApiUrl: { type: String, required: true },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(BookingActionsProvider, null, {
    default: _withCtx(() => [
      _createVNode(_unref(BookingCalendar), {
        "room-id": __props.roomId,
        "room-booking-api-url": __props.roomBookingApiUrl,
        "user-api-url": __props.userApiUrl,
        "overlay-concert-requests-api-url": __props.concertRequestCalendarApiUrl,
        mode: "single-room"
      }, null, 8 /* PROPS */, ["room-id", "room-booking-api-url", "user-api-url", "overlay-concert-requests-api-url"])
    ]),
    _: 1 /* STABLE */
  }))
}
}

}